module.exports = __webpack_public_path__ + "img/evoredtiger.310f0b8a.png";